import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { ElementGroup } from 'components/Editor/EditorElements/elements.types'
import { genElementConfig } from 'components/Editor/EditorElements/genElementConfig'
import { t } from 'services/Translation'

import Demo from '../MediaDemo'
import AudioElement from '../MediaElement'
import AudioFormValue from '../MediaFormValue'
import icon from '../assets/audio.svg'
import AudioFormBrand from './AudioFormBrand'
import { STYLE_FORM_SCHEMA } from './AudioFormStyle'

export default genElementConfig(CONFIG_ELEMENTS.audio, {
  label: t('elements.audio.label'),
  icon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: AudioElement,
  Demo: [Demo('audio')],
  FormValue: AudioFormValue,
  FormBrand: AudioFormBrand,
  EditorActions: null,
})
